import PageHeader from '../Components/PageHeader';
import ContactBand from '../Components/ContactBand';
import { clientGroups } from '../data/site';

const Clients = () => (
  <>
    <PageHeader eyebrow="Clients" title="The hospitals we serve">
      We have served 100+ clients, including these private and government institutions.
    </PageHeader>

    <section className="section">
      <div className="container client-groups">
        {clientGroups.map((group) => (
          <div key={group.title}>
            <h2 className="client-groups__title">{group.title}</h2>
            <ul className="client-list">
              {group.clients.map((client) => (
                <li key={client.name}>
                  <h3>{client.name}</h3>
                  <p>{client.desc}</p>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>

    <ContactBand />
  </>
);

export default Clients;
